import { CIcon } from '~/icons/types'

export const ciCarService: CIcon = {
  width: '32',
  height: '32',
  paths: [
    {
      d:
        'M30.666 26.703h-.609V4.63a.667.667 0 0 0-.666-.667h-2.55a.667.667 0 0 0-.667.667V18.4h-2.493v-1.316a1.927 1.927 0 0 0 1.276-1.805v-2a1.934 1.934 0 0 0-.572-1.367L22.34 9.88l-.99-3.915A1.935 1.935 0 0 0 19.468 4.5h-6.935a1.935 1.935 0 0 0-1.883 1.466L9.66 9.88l-2.047 2.027a1.948 1.948 0 0 0-.57 1.366v2a1.928 1.928 0 0 0 1.276 1.806V18.4H5.825V4.63a.667.667 0 0 0-.667-.666h-2.55a.667.667 0 0 0-.667.667v22.072h-.608a.667.667 0 1 0 0 1.333h5.101a.666.666 0 1 0 0-1.333h-.609v-6.97H26.174v6.974h-.609a.667.667 0 1 0 0 1.333h5.101a.666.666 0 1 0 0-1.333v-.004Zm-26.174 0H3.275V5.297h1.217v21.406Zm7.45-20.4a.606.606 0 0 1 .59-.454h6.933a.606.606 0 0 1 .59.454l.826 3.265h-9.765l.825-3.265Zm-1.068 12.104H9.652v-1.188h1.217l.005 1.188Zm8.934 0h-7.6V17.2h7.6v1.207Zm2.55 0h-1.217v-1.188h1.218v1.188Zm1.276-5.052h-2.533a.667.667 0 1 0 0 1.333h2.523v.599a.601.601 0 0 1-.61.596H8.986a.604.604 0 0 1-.61-.596v-.599H10.9a.666.666 0 1 0 0-1.333H8.376v-.079a.596.596 0 0 1 .176-.421l1.981-1.964h10.934l1.98 1.962a.594.594 0 0 1 .177.42l.01.082Zm5.1 13.354h-1.216V5.297h1.216V26.71Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'car-service',
  type: 'thin'
}
